<template>
  <div class="px-10 py-4 bg-custom-light">
    <div class="row">
      <div class="col-12 mb-3">
        <p class="heading-5 mb-0">{{$t('hotel.concierge.fitur.things-to-know')}}</p>
      </div>
      <div class="col-4">
        <p class="body-1-2 mb-2">{{$t('general.information')}}</p>
        <div class="row mb-1">
          <div class="col-1"><img src="../../assets/img/icon/location-dark.png" width="15"></div>
          <div class="col-10">{{getMerchant.address}}</div>
        </div>
        <template >
          <div class="row mb-1">
            <div class="col-1"><img src="../../assets/img/icon/time-dark.png" width="16"></div>
            <div class="col-10">
              <p class="mb-0 body-2-2 font-regular d-inline-block">
                <template v-if="getMerchant.use_daily_operational_hour">
                  <template v-if="opening_time.all_day_open && opening_time.is_same_hour.weekend && opening_time.is_same_hour.weekday">
                    <b>Week<span class="text-green">day</span></b> Operating Hours {{formatHour(opening_time.all_day[1].operational_hour.start)}} - {{formatHour(opening_time.all_day[1].operational_hour.end)}}
                  </template>
                  <template v-else-if="opening_time.today.is_open">
                    Opening Today {{formatHour(opening_time.today.operational_hour.start)}}
                  </template>
                  <template v-else>
                    Today is closed
                  </template>
                </template>
                <template v-else>
                  Opening {{formatHour(getMerchant.time_start)}}
                </template>
              </p>
            </div>
          </div>
          <div class="row mb-1" v-if="!getMerchant.use_daily_operational_hour || is_day_weekend_and_weekday_same_hour || is_today_open">
            <div class="col-1"><img src="../../assets/img/icon/time-dark.png" width="16"></div>
            <div class="col-10">
              <p class="mb-0 body-2-2 font-regular d-inline-block">
                <template v-if="getMerchant.use_daily_operational_hour">
                  <template v-if="opening_time.all_day_open && opening_time.is_same_hour.weekend && opening_time.is_same_hour.weekday">
                    <b>Week<span class="text-orange">end</span></b> Operating Hours {{formatHour(opening_time.all_day[0].operational_hour.start)}} - {{formatHour(opening_time.all_day[0].operational_hour.end)}}
                  </template>
                  <template v-else-if="opening_time.today.is_open">
                    Closing Today {{formatHour(opening_time.today.operational_hour.end)}}
                  </template>
                </template>
                <template v-else>
                  Closing {{formatHour(getMerchant.time_end)}}
                </template>
              </p>
            </div>
          </div>
        </template>
      </div>
      <div class="col-4">
        <p class="body-1-2 mb-2">{{$t('hotel.concierge.fitur.terms-conditions')}}</p>
        <p class="body-2-2 text-truncate-4 mb-2" style="height:84px !important;" v-html="getMerchant.terms_and_conditions"></p>
        <div class="d-table link-green-arrow">
          <p class="mb-0 d-inline-block aling-middle" @click="togglePopupInfo($t('hotel.concierge.fitur.terms-conditions'),getMerchant.terms_and_conditions)">{{$t('hotel.concierge.fitur.read-more')}}</p>
          <i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12" ></i>
        </div>
      </div>
      <div class="col-4">
        <p class="body-1-2 mb-2">{{$t('merchant.cancellation-policy')}}</p>
        <p class="body-2-2 text-truncate-4 mb-2" style="height:84px !important;" v-html="getMerchant.cancellation_policy"></p>
        <div class="d-table link-green-arrow ml-auto">
          <p class="mb-0 d-inline-block aling-middle" @click="togglePopupInfo($t('merchant.cancellation-policy'),getMerchant.cancellation_policy)">{{$t('hotel.concierge.fitur.read-more')}}</p>
          <i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12" ></i>
        </div>
      </div>
      <div class="col-12 my-4 pt-3">
        <div class="w-100 border-b-form">

        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-7 align-self-center">
            <p class="body-2-2 mb-0">Copyright © {{today.getFullYear()}} {{getMerchant.name}} All Right Reserved</p>
          </div>
          <div class="col-5 align-self-center text-right">
            <div class="d-inline-block align-middle ml-3 cursor-pointer" v-b-tooltip.hover :title="socmed.title" v-for="socmed in social_media" v-html="socmed.icon" @click="socmedClicked(socmed)">
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="show_detail">
      <div class="position-relative z-index-1045">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-12 col-lg-9 position-relative">
                  <div class="rounded-4 bg-white">
                    <div class="row no-gutters">
                      <div class="col-12 pop-up-currency-language position-relative h-96vh" style="overflow-y: scroll;height: 90vh;">
                        <img src="../../assets/img/icon/cancel.png"
                          class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute"
                          width="33" 
                          style="z-index: 1038;right: 0"
                          @click="toggleDetail()">
                          <div class="w-100 py-4 px-5">
                            <p class="mb-4 body-2-2 font-bold text-20 d-block">{{$t('hotel.choose-language')}}</p>
                            <div class="row slim-grid-row">
                              <div class="col-xl-4 col-lg-4 col-md-6 col-6 mb-3 rounded-6 cursor-pointer" @click="changeLanguage(list.iso_code)" :class="{'border-green cur-box-green':getCurrentLanguage == list.iso_code,'cur-box':getCurrentLanguage != list.iso_code}" v-for="list in getMerchant.language">
                                <div class="px-2 py-2 my-1">
                                  <div class="d-inline-block">
                                    <img :src="list.image_url" width="55" height="40" class="position-relative align-bottom rounded-3 object-fit border">
                                  </div>
                                  <div class="ml-2 d-inline-block position-relative" style="top: 1px">
                                    <p 
                                      class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
                                      :class="{'text-green':getCurrentLanguage == list.iso_code}">
                                      {{list.name}}</p>
                                    <p 
                                      class="mb-0 body-2 text-12 font-regular text-uppercase" 
                                      :class="{'text-green':getCurrentLanguage == list.iso_code}">
                                      {{list.iso_code}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="w-100 py-4 px-5">
                            <p class="mb-4 body-2-2 font-bold text-20 d-block">{{$t('hotel.choose-currency')}}</p>
                            <div class="row slim-grid-row">
                              <div class="col-12 col-md-6 col-lg-3 mb-3 rounded-6"
                              :class="{'cur-box': currency.code != getCurrency.code, 'border-green cur-box-green': currency.code == getCurrency.code,'cursor-pointer': !is_load, 'cursor-loading': is_load}"
                              v-for="currency in currencys"
                              @click="changeCurrency(currency)">
                                <div class="p-2">
                                  <p 
                                    class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
                                    style="margin-bottom: -2px"
                                    :class="{'text-green': currency.code == getCurrency.code}">{{currency.name}}</p>
                                  <p 
                                    class="mb-0 body-2 text-14 font-regular"
                                    :class="{'text-green': currency.code == getCurrency.code}">
                                    {{currency.code}} - {{currency.symbol_native}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="position-relative z-index-1042">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 position-relative">
                    <div class="">
                      <div class="w-100 py-2 px-2" 
                        style="height: 100vh;background-color: #00000099">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>


    <!-- DETAIL BASIC INFORMATION -->
    <popup-detail 
    	direction="bottom" 
    	:show="popup_info.show"
      use_max_size
      wrapper_size="mobile"
    	:title="popup_info.title"
    	@close="togglePopupInfo">
    	<template v-slot:body>
	    	<div class="py-3 px-4">
	        <div class="html-desc" v-html="popup_info.body">
	        </div>
	    	</div>
	    </template>
    </popup-detail>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex';
  import currency from "@/data/currency"
	import axios from 'axios';
  import moment from 'moment'
  
  export default {
    data(){
      return{
        currencys: currency,
				is_load: false,
        language_selected: "",
        show_detail: false,
        popup_info:{
        	show: false,
        	title: '',
        	body: ''
        },
        opening_time: {
          today: {},
          all_day: [],
          all_day_open: false,
          is_same_hour: {
            weekend: false,
            weekday: false
          }
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getCurrency','getCurrentLanguage']),
      social_media(){
        let return_data = []
        if(this.$isNotEmpty(this.getMerchant.whatsapp_number)){
          return_data.push({
            title: 'Whatsapp',
            value: this.getMerchant.whatsapp_number,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5487 4.25C9.16775 4.25 3.97475 9.25175 3.9725 15.3988C3.971 17.3645 4.505 19.283 5.5175 20.9728L3.875 26.75L10.0122 25.1998C11.7194 26.0928 13.6176 26.5586 15.5442 26.5573H15.5487C21.9297 26.5573 27.1227 21.5548 27.125 15.4078C27.1265 12.4303 25.9235 9.6275 23.7372 7.52075C21.5517 5.41325 18.6455 4.25075 15.5487 4.25ZM15.5487 24.674H15.545C13.8185 24.674 12.125 24.227 10.6475 23.3825L10.295 23.1815L6.6545 24.101L7.6265 20.681L7.39775 20.3308C6.43693 18.8654 5.92545 17.151 5.92625 15.3988C5.9285 10.289 10.2455 6.13325 15.5525 6.13325C18.122 6.134 20.5377 7.09925 22.355 8.8505C24.1722 10.6018 25.172 12.9305 25.1705 15.407C25.1682 20.5168 20.852 24.674 15.548 24.674H15.5487ZM20.8265 17.7328C20.537 17.594 19.115 16.9198 18.8495 16.826C18.5847 16.7338 18.392 16.6858 18.1992 16.9648C18.0072 17.2438 17.4522 17.8715 17.2842 18.0568C17.1147 18.2428 16.946 18.2653 16.6565 18.1265C16.367 17.987 15.4347 17.693 14.3307 16.7435C13.4705 16.0055 12.89 15.0935 12.7212 14.8138C12.5525 14.5355 12.7032 14.3848 12.848 14.246C12.9777 14.1223 13.1375 13.9213 13.2815 13.7585C13.4255 13.5958 13.4735 13.4795 13.571 13.2935C13.667 13.1083 13.619 12.9448 13.5462 12.806C13.4735 12.6658 12.896 11.2948 12.6537 10.7375C12.4197 10.1945 12.1812 10.2673 12.0035 10.2583C11.8347 10.2508 11.6427 10.2485 11.4485 10.2485C11.2572 10.2485 10.943 10.3183 10.6775 10.5973C10.4127 10.8763 9.665 11.5498 9.665 12.9208C9.665 14.2925 10.7015 15.617 10.8462 15.803C10.991 15.9883 12.8862 18.803 15.788 20.0105C16.478 20.2963 17.0165 20.468 17.4372 20.597C18.1302 20.8093 18.761 20.7785 19.259 20.7073C19.814 20.627 20.9705 20.0338 21.2105 19.3835C21.452 18.7333 21.452 18.1753 21.38 18.059C21.3095 17.9428 21.116 17.873 20.8265 17.7328V17.7328Z" fill="#25D366"/></svg>`
          })
        }

        if(this.$isNotEmpty(this.getMerchant.website)){
          return_data.push({
            title: 'Website',
            value: this.getMerchant.website,
            icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_265_49)"><path d="M11.9941 23.3297C15.263 23.3297 17.9324 18.4968 17.9324 12.0177C17.9324 5.50318 15.2749 0.670259 11.9941 0.670259C8.71336 0.670259 6.05585 5.50318 6.05585 12.0177C6.05585 18.4968 8.72512 23.3297 11.9941 23.3297ZM11.9941 2.09309C14.2989 2.09309 16.3567 6.67907 16.3567 12.0177C16.3567 17.2621 14.2989 21.8951 11.9941 21.8951C9.68935 21.8951 7.63154 17.2621 7.63154 12.0177C7.63154 6.67907 9.68935 2.09309 11.9941 2.09309ZM11.2298 0.834883V23.1062H12.7702V0.834883H11.2298ZM11.9941 16.4155C8.37235 16.4155 5.16217 17.3679 3.51592 18.8848L4.70357 19.8609C6.25575 18.6261 8.78392 17.9558 11.9941 17.9558C15.2042 17.9558 17.7325 18.6261 19.2847 19.8609L20.4722 18.8848C18.826 17.3679 15.6159 16.4155 11.9941 16.4155ZM22.8476 11.218H1.14062V12.7584H22.8476V11.218ZM11.9941 7.63154C15.6159 7.63154 18.826 6.67907 20.4722 5.16217L19.2847 4.18618C17.7325 5.4091 15.2042 6.09112 11.9941 6.09112C8.78392 6.09112 6.25575 5.4091 4.70357 4.18618L3.51592 5.16217C5.16217 6.67907 8.37235 7.63154 11.9941 7.63154ZM11.9941 23.9882C18.5556 23.9882 23.9882 18.5439 23.9882 11.9941C23.9882 5.43262 18.5439 0 11.9823 0C5.43262 0 0 5.43262 0 11.9941C0 18.5439 5.44438 23.9882 11.9941 23.9882ZM11.9941 22.389C6.31454 22.389 1.59921 17.6737 1.59921 11.9941C1.59921 6.31454 6.30278 1.59921 11.9823 1.59921C17.6619 1.59921 22.389 6.31454 22.389 11.9941C22.389 17.6737 17.6737 22.389 11.9941 22.389Z" fill="black" fill-opacity="0.85"/></g><defs><clipPath id="clip0_265_49"><rect width="23.9882" height="24" fill="white"/></clipPath></defs></svg>`
          })
        }

        if(this.$isNotEmpty(this.getMerchant.youtube_link)){
          return_data.push({
            title: 'Youtube',
            value: this.getMerchant.youtube_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.5647 6.994C26.6757 7.29245 27.5545 8.17126 27.8529 9.28218C28.4001 11.3051 28.4167 15.5001 28.4167 15.5001C28.4167 15.5001 28.4167 19.7117 27.8695 21.718C27.571 22.8289 26.6922 23.7077 25.5813 24.0062C23.575 24.5534 15.5 24.5534 15.5 24.5534C15.5 24.5534 7.42502 24.5534 5.41871 24.0062C4.30778 23.7077 3.42898 22.8289 3.13052 21.718C2.58334 19.6951 2.58334 15.5001 2.58334 15.5001C2.58334 15.5001 2.58334 11.3051 3.11394 9.29877C3.4124 8.18784 4.2912 7.30904 5.40213 7.01058C7.40844 6.4634 15.4834 6.44682 15.4834 6.44682C15.4834 6.44682 23.5584 6.44682 25.5647 6.994ZM19.6121 15.5001L12.9134 19.3801V11.6201L19.6121 15.5001Z" fill="#FF0000"/></svg>`
          })
        }

        if(this.$isNotEmpty(this.getMerchant.facebook_link)){
          return_data.push({
            title: 'Facebook',
            value: this.getMerchant.facebook_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.4166 15.5784C28.4166 8.40099 22.6343 2.58333 15.5 2.58333C8.36567 2.58333 2.58331 8.40099 2.58331 15.5784C2.58331 22.066 7.30565 27.4419 13.4815 28.4167V19.3354H10.2024V15.5775H13.4815V12.7152C13.4815 9.45844 15.4096 7.65872 18.3606 7.65872C19.7728 7.65872 21.2522 7.91274 21.2522 7.91274V11.1109H19.6221C18.0179 11.1109 17.5184 12.1132 17.5184 13.1414V15.5784H21.1006L20.528 19.3345H17.5184V28.4167C23.6943 27.4419 28.4166 22.066 28.4166 15.5784Z" fill="#1877F2"/></svg>`
          })
        }

        if(this.$isNotEmpty(this.getMerchant.instagram_link)){
          return_data.push({
            title: 'Instagram',
            value: this.getMerchant.instagram_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 3.875C12.3426 3.875 11.9474 3.88818 10.7074 3.94475C9.46972 4.00132 8.6242 4.19817 7.88485 4.4857C7.10985 4.7771 6.40692 5.23435 5.82567 5.82645C5.23452 6.40703 4.77699 7.10946 4.48492 7.88485C4.19895 8.6242 4.00132 9.4705 3.94475 10.7082C3.88895 11.9474 3.875 12.3419 3.875 15.5C3.875 18.6581 3.88818 19.0526 3.94475 20.2926C4.00132 21.5303 4.19817 22.3758 4.4857 23.1151C4.7771 23.8901 5.23435 24.5931 5.82645 25.1743C6.40704 25.7655 7.10947 26.223 7.88485 26.5151C8.6242 26.8018 9.46972 26.9987 10.7074 27.0552C11.9474 27.1118 12.3426 27.125 15.5 27.125C18.6573 27.125 19.0526 27.1118 20.2926 27.0552C21.5303 26.9987 22.3758 26.8018 23.1151 26.5143C23.8901 26.2229 24.5931 25.7656 25.1743 25.1735C25.7655 24.593 26.223 23.8905 26.5151 23.1151C26.8018 22.3758 26.9987 21.5303 27.0552 20.2926C27.1118 19.0526 27.125 18.6573 27.125 15.5C27.125 12.3426 27.1118 11.9474 27.0552 10.7074C26.9987 9.46972 26.8018 8.6242 26.5143 7.88485C26.2224 7.10912 25.7649 6.4064 25.1735 5.82567C24.593 5.23452 23.8905 4.77699 23.1151 4.48492C22.3758 4.19895 21.5295 4.00132 20.2918 3.94475C19.0526 3.88895 18.6581 3.875 15.5 3.875ZM15.5 5.96982C18.6039 5.96982 18.972 5.98145 20.198 6.03725C21.3311 6.08917 21.9464 6.2775 22.3564 6.43792C22.8989 6.64795 23.2864 6.9006 23.6933 7.3067C24.1002 7.71357 24.352 8.10107 24.5621 8.64357C24.7217 9.05355 24.9108 9.6689 24.9627 10.8019C25.0185 12.028 25.0302 12.3961 25.0302 15.5C25.0302 18.6039 25.0185 18.972 24.9627 20.198C24.9108 21.3311 24.7225 21.9464 24.5621 22.3564C24.376 22.8614 24.0792 23.3182 23.6933 23.6933C23.3183 24.0792 22.8614 24.3761 22.3564 24.5621C21.9464 24.7217 21.3311 24.9108 20.198 24.9627C18.972 25.0185 18.6046 25.0302 15.5 25.0302C12.3953 25.0302 12.028 25.0185 10.8019 24.9627C9.6689 24.9108 9.05355 24.7225 8.64357 24.5621C8.13863 24.376 7.6818 24.0792 7.3067 23.6933C6.92089 23.3182 6.62402 22.8613 6.43792 22.3564C6.27827 21.9464 6.08917 21.3311 6.03725 20.198C5.98145 18.972 5.96982 18.6039 5.96982 15.5C5.96982 12.3961 5.98145 12.028 6.03725 10.8019C6.08917 9.6689 6.2775 9.05355 6.43792 8.64357C6.64795 8.10107 6.9006 7.71357 7.3067 7.3067C7.68175 6.92078 8.13859 6.62391 8.64357 6.43792C9.05355 6.27827 9.6689 6.08917 10.8019 6.03725C12.028 5.98145 12.3961 5.96982 15.5 5.96982V5.96982Z" fill="#C419A0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 19.3789C14.9906 19.3789 14.4862 19.2785 14.0156 19.0836C13.545 18.8887 13.1174 18.603 12.7572 18.2428C12.397 17.8826 12.1113 17.455 11.9164 16.9844C11.7215 16.5138 11.6211 16.0094 11.6211 15.5C11.6211 14.9906 11.7215 14.4862 11.9164 14.0156C12.1113 13.545 12.397 13.1174 12.7572 12.7572C13.1174 12.397 13.545 12.1113 14.0156 11.9164C14.4862 11.7215 14.9906 11.6211 15.5 11.6211C16.5287 11.6211 17.5153 12.0298 18.2428 12.7572C18.9702 13.4847 19.3789 14.4713 19.3789 15.5C19.3789 16.5287 18.9702 17.5154 18.2428 18.2428C17.5153 18.9702 16.5287 19.3789 15.5 19.3789V19.3789ZM15.5 9.52475C13.9153 9.52475 12.3954 10.1543 11.2749 11.2749C10.1543 12.3954 9.52475 13.9153 9.52475 15.5C9.52475 17.0847 10.1543 18.6046 11.2749 19.7251C12.3954 20.8457 13.9153 21.4753 15.5 21.4753C17.0847 21.4753 18.6046 20.8457 19.7251 19.7251C20.8457 18.6046 21.4752 17.0847 21.4752 15.5C21.4752 13.9153 20.8457 12.3954 19.7251 11.2749C18.6046 10.1543 17.0847 9.52475 15.5 9.52475V9.52475ZM23.2136 9.41625C23.2136 9.79085 23.0648 10.1501 22.7999 10.415C22.535 10.6799 22.1757 10.8287 21.8011 10.8287C21.4265 10.8287 21.0673 10.6799 20.8024 10.415C20.5375 10.1501 20.3887 9.79085 20.3887 9.41625C20.3887 9.04165 20.5375 8.68239 20.8024 8.41751C21.0673 8.15262 21.4265 8.00381 21.8011 8.00381C22.1757 8.00381 22.535 8.15262 22.7999 8.41751C23.0648 8.68239 23.2136 9.04165 23.2136 9.41625" fill="#C419A0"/></svg>`
          })
        }

        if(this.$isNotEmpty(this.getMerchant.tiktok_link)){
          return_data.push({
            title: 'Tiktok',
            value: this.getMerchant.tiktok_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.3992 7.76154C22.0077 6.85423 21.0033 5.40254 20.69 3.71026C20.6223 3.34463 20.5851 2.96834 20.5851 2.58333H16.1439L16.1367 20.3824C16.0621 22.3756 14.4216 23.9754 12.4105 23.9754C11.7855 23.9754 11.1969 23.8191 10.6787 23.5464C9.49041 22.9211 8.67718 21.6755 8.67718 20.2421C8.67718 18.1834 10.352 16.5086 12.4105 16.5086C12.7948 16.5086 13.1634 16.572 13.5121 16.6812V12.1471C13.1512 12.098 12.7846 12.0673 12.4105 12.0673C7.90294 12.0673 4.2359 15.7345 4.2359 20.2421C4.2359 23.0077 5.61767 25.4552 7.7257 26.9351C9.05352 27.8673 10.6686 28.4167 12.4105 28.4167C16.9181 28.4167 20.5851 24.7497 20.5851 20.2421V11.2164C22.3271 12.4667 24.4612 13.2034 26.7641 13.2034V8.76214C25.5236 8.76214 24.3682 8.39335 23.3992 7.76154" fill="#010101"/></svg>`
          })
        }

        if(this.$isNotEmpty(this.getMerchant.tripadvisor_link)){
          return_data.push({
            title: 'Tripadvisor',
            value: this.getMerchant.tripadvisor_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3323 16.8088C11.3323 17.2619 11.198 17.7048 10.9463 18.0814C10.6946 18.4581 10.3368 18.7517 9.91827 18.9251C9.49971 19.0985 9.03914 19.1438 8.5948 19.0555C8.15045 18.9671 7.7423 18.7489 7.42195 18.4286C7.1016 18.1082 6.88344 17.7001 6.79505 17.2557C6.70667 16.8114 6.75203 16.3508 6.9254 15.9322C7.09877 15.5137 7.39237 15.1559 7.76907 14.9042C8.14576 14.6525 8.58863 14.5182 9.04168 14.5182C9.64919 14.5182 10.2318 14.7595 10.6614 15.1891C11.091 15.6187 11.3323 16.2013 11.3323 16.8088V16.8088ZM21.9526 14.5182C21.4996 14.5182 21.0567 14.6525 20.68 14.9042C20.3033 15.1559 20.0097 15.5137 19.8363 15.9322C19.663 16.3508 19.6176 16.8114 19.706 17.2557C19.7944 17.7001 20.0125 18.1082 20.3329 18.4286C20.6532 18.7489 21.0614 18.9671 21.5057 19.0555C21.9501 19.1438 22.4106 19.0985 22.8292 18.9251C23.2478 18.7517 23.6055 18.4581 23.8572 18.0814C24.1089 17.7048 24.2433 17.2619 24.2433 16.8088C24.2431 16.2016 24.0019 15.6194 23.5726 15.19C23.1433 14.7606 22.5611 14.5192 21.9539 14.5188L21.9526 14.5182ZM28.411 16.8088C28.411 20.3736 25.5184 23.2637 21.9526 23.2637C20.3261 23.2663 18.759 22.6524 17.567 21.5457L15.5 23.7947L13.4321 21.5431C12.2402 22.6511 10.6725 23.2659 9.04518 23.2637C5.48196 23.2637 2.59034 20.3736 2.59034 16.8088C2.58913 15.9108 2.77583 15.0224 3.13844 14.2008C3.50104 13.3792 4.03154 12.6426 4.69582 12.0383L2.58334 9.73998H7.27661C9.7033 8.08851 12.5707 7.20535 15.5061 7.20535C18.4414 7.20535 21.3088 8.08851 23.7355 9.73998H28.4167L26.3045 12.0383C26.969 12.6425 27.4998 13.3791 27.8626 14.2007C28.2254 15.0223 28.4123 15.9107 28.4113 16.8088H28.411ZM13.4117 16.8088C13.4117 15.9448 13.1555 15.1002 12.6755 14.3818C12.1954 13.6634 11.5132 13.1035 10.7149 12.7729C9.91668 12.4423 9.03831 12.3558 8.19091 12.5244C7.34351 12.6929 6.56513 13.109 5.9542 13.72C5.34328 14.331 4.92725 15.1094 4.75873 15.9568C4.5902 16.8042 4.67676 17.6826 5.00744 18.4808C5.33813 19.279 5.89809 19.9612 6.61652 20.4412C7.33495 20.9212 8.17958 21.1773 9.04359 21.1773C9.61727 21.1773 10.1853 21.0644 10.7154 20.8448C11.2454 20.6253 11.727 20.3035 12.1326 19.8979C12.5383 19.4922 12.8601 19.0106 13.0796 18.4806C13.2991 17.9506 13.4121 17.3825 13.412 16.8088H13.4117ZM20.3473 10.2869C18.8111 9.64685 17.1634 9.31734 15.4992 9.31734C13.835 9.31734 12.1873 9.64685 10.6512 10.2869C13.4092 11.3425 15.5 13.8081 15.5 16.6828C15.5 13.8084 17.5905 11.3425 20.3476 10.2872L20.3473 10.2869ZM26.322 16.8088C26.322 15.9448 26.0658 15.1002 25.5858 14.3818C25.1058 13.6634 24.4235 13.1035 23.6252 12.7729C22.827 12.4423 21.9486 12.3558 21.1012 12.5244C20.2538 12.6929 19.4754 13.109 18.8645 13.72C18.2536 14.331 17.8376 15.1094 17.669 15.9568C17.5005 16.8042 17.5871 17.6826 17.9178 18.4808C18.2484 19.279 18.8084 19.9612 19.5268 20.4412C20.2453 20.9212 21.0899 21.1773 21.9539 21.1773C23.1125 21.1773 24.2236 20.717 25.0428 19.8978C25.8621 19.0785 26.3223 17.9674 26.3223 16.8088H26.322Z" fill="#00AF87"/></svg>`
          })
        }


        return return_data
      },
      today(){
        return new Date
      },
      is_day_weekend_and_weekday_same_hour(){
        // Saturday & Sunday same daily hour
        // and weekday same daily hour (per daily)
        return this.getMerchant.use_daily_operational_hour && this.opening_time.all_day_open && this.opening_time.is_same_hour.weekend && this.opening_time.is_same_hour.weekday
      },
      is_today_open(){
        return this.getMerchant.use_daily_operational_hour && this.opening_time.today.is_open
      }
    },
    created(){
      this.openingDays()
    },
    methods:{
      ...mapMutations(['setCurrency','setBaseRate','setLanguageMutation']),
      socmedClicked(data){
        let url = data.title == 'Whatsapp' ? `https://api.whatsapp.com/send/?phone=${data.value}&text&app_absent=0` : data.value
        
        this.$openLink(url,'_blank')
      },
      toggleDetail(){
				this.show_detail = !this.show_detail
			},
      formatTime(time){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
      changeCurrency(data){
        this.is_load = true
        this.$convertCurrency(data.code)
        .then(()=>{
          this.setCurrency(data)
          this.toggleDetail()
        })
        .finally(()=>this.is_load)
			},
      changeLanguage(data){
        console.log("data :", data)
        this.setLanguageMutation(data)
        window.location.reload();
      },
      togglePopupInfo(title='',body=''){
      	this.popup_info.show = !this.popup_info.show
    		this.popup_info.title = title
    		this.popup_info.body = body
      },
      openingDays() {
        let today = moment().format("d")
        let day_in_week = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday']
        let opening_days = []
        let count_day_open = 0 
        day_in_week.forEach((day,day_i)=>{
          let sale = `sale_${day}`
          let hour_start = `time_start_${day}`
          let hour_end = `time_end_${day}`
          let open_day = {
            day: moment(day_i,'d').format('dddd'),
            is_open: this.getMerchant[sale],
            operational_hour: !this.getMerchant.use_daily_operational_hour ? {} : {
              start: this.formatHour(this.getMerchant[hour_start]),
              end: this.formatHour(this.getMerchant[hour_end])
            }
          }
          if(this.getMerchant[sale]) count_day_open++
          opening_days.push(open_day)
        })
        
        let is_weekend_same_start = false
        let is_weekday_same_start = false
        if(this.getMerchant.use_daily_operational_hour && count_day_open == 7){
          let is_weekend_open = opening_days[0].is_open && opening_days[6].is_open
          is_weekend_same_start = is_weekend_open && opening_days[0].operational_hour.start == opening_days[6].operational_hour.start


          let weekday_start_time = ""
          let total_weekday_same_start_time = 1
          for (let i = 1; i < 6; i++) {
            const el = opening_days[i];
            if(weekday_start_time != ''){
              if(weekday_start_time == el.operational_hour.start) total_weekday_same_start_time++
            }else{
              weekday_start_time = el.is_open ? el.operational_hour.start : ''
            }
          }
          is_weekday_same_start = total_weekday_same_start_time == 5
        }
      
        this.opening_time = {
          today: opening_days[today],
          all_day: opening_days,
          all_day_open: count_day_open == 7 ? true : false,
          is_same_hour: {
            weekend: is_weekend_same_start,
            weekday: is_weekday_same_start
          }
        }
      },
      formatHour(time,is_detail=false){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
    }    
  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/Footer.vue